/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Releasestats1Inputs */

const id_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik rilis`)
};

const ms_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik keluaran`)
};

const da_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivelsesstatistik`)
};

const de_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsstatistiken`)
};

const en_us2_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Stats`)
};

const es_es2_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de lanzamientos`)
};

const es_mx2_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de lanzamientos`)
};

const fil_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika ng Release`)
};

const fr_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques de sorties`)
};

const it_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche uscite`)
};

const hu_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelenési statisztikák`)
};

const nl_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasestatistieken`)
};

const no_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivelsesstatistikk`)
};

const pl_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki wydań`)
};

const pt_br2_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de lançamento`)
};

const pt_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de lançamentos`)
};

const ro_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici lansări`)
};

const fi_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisutilastot`)
};

const sv_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släppstatistik`)
};

const vi_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê phát hành`)
};

const tr_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış İstatistikleri`)
};

const cs_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky vydání`)
};

const bg_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика на издаванията`)
};

const ru_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релизов`)
};

const uk_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релізів`)
};

const ar_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات الإصدارات`)
};

const hi_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ आँकड़े`)
};

const th_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติการวางจำหน่าย`)
};

const ja_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース統計`)
};

const zh_cn2_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布统计`)
};

const zh_hant1_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發布統計`)
};

const ko_nav_releasestats1 = /** @type {(inputs: Nav_Releasestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 통계`)
};

/**
* | output |
* | --- |
* | "Release Stats" |
*
* @param {Nav_Releasestats1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_releasestats1 = /** @type {((inputs?: Nav_Releasestats1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Releasestats1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_releasestats1(inputs)
	if (locale === "ms") return ms_nav_releasestats1(inputs)
	if (locale === "da") return da_nav_releasestats1(inputs)
	if (locale === "de") return de_nav_releasestats1(inputs)
	if (locale === "en-US") return en_us2_nav_releasestats1(inputs)
	if (locale === "es-ES") return es_es2_nav_releasestats1(inputs)
	if (locale === "es-MX") return es_mx2_nav_releasestats1(inputs)
	if (locale === "fil") return fil_nav_releasestats1(inputs)
	if (locale === "fr") return fr_nav_releasestats1(inputs)
	if (locale === "it") return it_nav_releasestats1(inputs)
	if (locale === "hu") return hu_nav_releasestats1(inputs)
	if (locale === "nl") return nl_nav_releasestats1(inputs)
	if (locale === "no") return no_nav_releasestats1(inputs)
	if (locale === "pl") return pl_nav_releasestats1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_releasestats1(inputs)
	if (locale === "pt") return pt_nav_releasestats1(inputs)
	if (locale === "ro") return ro_nav_releasestats1(inputs)
	if (locale === "fi") return fi_nav_releasestats1(inputs)
	if (locale === "sv") return sv_nav_releasestats1(inputs)
	if (locale === "vi") return vi_nav_releasestats1(inputs)
	if (locale === "tr") return tr_nav_releasestats1(inputs)
	if (locale === "cs") return cs_nav_releasestats1(inputs)
	if (locale === "bg") return bg_nav_releasestats1(inputs)
	if (locale === "ru") return ru_nav_releasestats1(inputs)
	if (locale === "uk") return uk_nav_releasestats1(inputs)
	if (locale === "ar") return ar_nav_releasestats1(inputs)
	if (locale === "hi") return hi_nav_releasestats1(inputs)
	if (locale === "th") return th_nav_releasestats1(inputs)
	if (locale === "ja") return ja_nav_releasestats1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_releasestats1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_releasestats1(inputs)
	return ko_nav_releasestats1(inputs)
});
export { nav_releasestats1 as "nav.releaseStats" }